import { StatsThemeBaseColors } from '../types'

export const base: StatsThemeBaseColors = {
  bubblegum: '#E882AA',
  flamingo: '#FC7676',
  azure: '#0076BA',
  fern: '#4F8111',
  olive: '#526C03',
  jungle: '#064C37',
}
